<template>
    <form class="form-contato" id="formContato">

        <div class="form-group">
            <label for="" class="txt-p txt-cores-3">Nome completo:</label>
            <input type="text" class="form-control" id="nmUsuario" maxlength="50" aria-describedby="nomeErro" placeholder="" required v-model="solicitacao.nmUsuario">
            <small id="nomeErro" class="form-text text-muted"></small>
        </div>

        <div class="form-group">
            <label for="" class="txt-p txt-cores-3">Instituição:</label>
            <input type="text" class="form-control" id="nmEmpresaInstituicao" maxlength="100" aria-describedby="nomeErro" placeholder="" required v-model="solicitacao.nmEmpresaInstituicao">
            <small id="nomeErro" class="form-text text-muted"></small>
        </div>

        <div class="form-group">
            <label for="" class="txt-p txt-cores-3">CNPJ:</label>
            <vue-mask class="form-control"
                       id="nrCnpj"
                      v-model="solicitacao.nrCnpj"
                      mask="00.000.000/0000-00"
                      :raw="false"
                      :options="options" required>
            </vue-mask>
            <small id="nomeErro" class="form-text text-muted"></small>
        </div>

        <div class="form-group">
            <label for="" class="txt-p txt-cores-3">Telefone:</label>
            <vue-mask class="form-control"
                      id="nrTelefone"
                      v-model="solicitacao.nrTelefone"
                      mask="(00) 00000-0000"
                      :raw="false"
                      :options="options" required>
            </vue-mask>
            <small id="nomeErro" class="form-text text-muted"></small>
        </div>

        <div class="form-group">
            <label for="" class="txt-p txt-cores-3">Email:</label>
            <input type="email" class="form-control" id="dsEmail" maxlength="100" aria-describedby="emailErro" placeholder="" required v-model="solicitacao.dsEmail">
            <small id="emailErro" class="form-text text-muted"></small>
        </div>

        <div class="form-group">
            <label for="" class="txt-p txt-cores-3">UF:</label>
            <select id="nmUf" class="form-control" required v-model="solicitacao.nmUf">
                <option value="" selected disabled> -- Selecione --</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AM">Amazonas</option>
                <option value="AP">Amapá</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RO">Rondônia</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SE">Sergipe</option>
                <option value="SP">São Paulo</option>
                <option value="TO">Tocantins</option>
            </select>
            
            <small id="emailErro" class="form-text text-muted"></small>
        </div>

        <div class="mt-3 d-flex w-100 justify-content-end">
            <button :class="'btn btn-roxo '+(txtBotao == 'ENVIAR'?'btn-enviar':'')" type="button" @click="enviar">
                {{txtBotao}}
            </button>
        </div>
    </form>
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'
    import vueMask from 'vue-jquery-mask'

    export default {
        name: 'FormContato',
        components: {
            vueMask,
        },
        props: {
            txtBotao: {
                type: String,
                default: 'ENVIAR'
            },
        },
        data: function () {
            return {
                options: {
                    placeholder: '',
                    // http://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
                },
                solicitacao: {
                    nmUsuario: '',
                    nmEmpresaInstituicao: '',
                    nrCnpj: '',
                    nrTelefone: '',
                    dsEmail: '',
                    nmUf: '',
                }
            }
        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Utilidade/SolicitacaoContato`, $this.solicitacao)
                        .then(function(){
                            avisoSucesso("Enviado!");
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data.msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formContato')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .form-contato {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(122, 122, 122, 0.25);
        border-radius: 5px;

        padding: 30px;
    }

    .btn-enviar {
        font-size: 14px;
        font-weight: 700;
        padding-left: 2rem;
        padding-right: 2rem;
    }
</style>

